/** Web 路由名 ↔ 路径映射（与 linking.config 对齐） */
export const ROUTE_PATHS: Record<string, string> = {
  AppIntro: "/",
  Login: "/login",
  Register: "/register",
  ForgetPassword: "/forgot-password",
  VerifyCode: "/verify-code",
  ResetPassword: "/reset-password",
  Home: "/",
  ChatList: "/chats",
  ContactList: "/contacts",
  GroupChatList: "/groups",
  Me: "/me",
  Console: "/debug",
  Chat: "/room",
  Setting: "/settings",
  BasicInfo: "/profile",
  AddContact: "/add-contact",
  NoticeCenter: "/notices",
  PersonalCard: "/personal-card",
  FindChatRecord: "/search",
  ImageGallery: "/gallery",
  QrcodeScan: "/scan",
  AddGroupChat: "/add-group-chat",
  AutoRedPacketBetSetting: "/auto-red-packet-bet",
  GroupChatManagement: "/group-management",
  GroupChatInformation: "/group-info",
  GroupAnnouncementDetail: "/group-announcement",
  RevenueStatistics: "/revenue",
  AddGroupMember: "/add-group-member",
  AddChannel: "/add-channel",
  ChannelChatInformation: "/channel-info",
  ChannelChatManagement: "/channel-management",
  RemoveGroupMember: "/remove-group-member",
  UpdateGroupTitle: "/update-group-title",
  FriendList: "/friend-list",
  ChannelList: "/channel-list",
  GroupList: "/group-list",
  GroupCard: "/group-card",
  Avatar: "/avatar",
  UpdateCurrentUserEmail: "/update-email",
  UpdateCurrentUserGender: "/update-gender",
  SearchChatContent: "/search-content",
  UpdateContact: "/update-contact",
  Info: "/info",
  Accusation: "/accusation",
  AccusationSuccess: "/accusation-success",
  PrivacyAndSafety: "/privacy",
  MyAccount: "/my-account",
  VideoRecorder: "/video-recorder",
  Share: "/share",
  SecurityGoogle: "/security-google",
  GroupAssistant: "/group-assistant",
  NotDisturbMode: "/not-disturb",
  NotificationBell: "/notification-bell",
  LanguageSettings: "/language",
  FontsizeSettings: "/fontsize",
  LoginDevice: "/login-device",
  ClearCacheData: "/clear-cache",
  OnlineTimeSettings: "/online-time",
  SelfDestructTimeSettings: "/self-destruct",
  AddMethodSettings: "/add-method",
  BlackList: "/black-list",
  ForwardMessage: "/forward",
}

/** 仅以 URL 查询为准，忽略 history.state 中同名残留（H5 切换会话时 state 易脏） */
export const ROUTE_URL_ONLY_PARAMS: Record<string, string[]> = {
  Chat: ["chat_id"],
  GroupChatManagement: ["chat_id"],
  GroupChatInformation: ["chat_id"],
  ChannelChatManagement: ["chat_id"],
  ChannelChatInformation: ["chat_id"],
  GroupAnnouncementDetail: ["chat_id"],
}

/** 不可出现在 URL 查询串中的路由参数（防篡改） */
export const ROUTE_STATE_PARAMS: Record<string, string[]> = {
  PersonalCard: ["userId", "isSendMessageButtonVisible"],
  Info: ["userId"],
  UpdateContact: ["userId"],
  Accusation: ["userId"],
  Chat: ["name", "scrollToMessageId"],
  GroupChatManagement: [],
  GroupChatInformation: [],
  ChannelChatManagement: [],
  ChannelChatInformation: [],
  ImageGallery: ["images", "index"],
  GroupCard: ["chat"],
  ForwardMessage: ["messageID"],
  RevenueStatistics: ["chat_id", "isCurrentUserRole"],
  GroupAnnouncementDetail: ["title"],
  VerifyCode: ["data"],
  ResetPassword: ["username", "email", "phone", "code"],
}

export function splitRouteParams(name: string, params?: Record<string, unknown>) {
  const stateKeys = new Set(ROUTE_STATE_PARAMS[name] ?? [])
  const urlParams: Record<string, unknown> = {}
  const state: Record<string, unknown> = {}
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value == null) return
      if (stateKeys.has(key)) state[key] = value
      else urlParams[key] = value
    })
  }
  return { urlParams, state }
}

export function pathForRoute(name: string, params?: Record<string, unknown>) {
  const { urlParams } = splitRouteParams(name, params)
  const base = ROUTE_PATHS[name] || `/${name.toLowerCase()}`
  if (Object.keys(urlParams).length === 0) return base
  const search = new URLSearchParams()
  Object.entries(urlParams).forEach(([key, value]) => {
    if (value != null) search.set(key, String(value))
  })
  const qs = search.toString()
  return qs ? `${base}?${qs}` : base
}

export function routeNameFromPathname(pathname: string) {
  const entry = Object.entries(ROUTE_PATHS).find(([, path]) => path === pathname)
  return entry?.[0]
}
